import React from "react";
import { Box, InputLabel } from "@mui/material";
import { dt } from "../../../themes/redesignTokens";

export interface FormFieldLabelProps {
  children: React.ReactNode;
  required?: boolean;
}

/**
 * Simple text label above a form field.
 *
 * Based on SR/RFS labelSx pattern (13px, weight 600, dt.textPrimary).
 * When `required`, wraps in MUI InputLabel for accessibility and asterisk.
 */
const FormFieldLabel: React.FC<FormFieldLabelProps> = ({
  children,
  required,
}) => {
  const labelStyles = {
    fontFamily: dt.font,
    fontSize: "13px",
    fontWeight: 600,
    color: dt.textPrimary,
    letterSpacing: "0.1px",
    mb: 0.5,
  };

  if (required) {
    return (
      <InputLabel
        required
        sx={{
          ...labelStyles,
          "& .MuiInputLabel-asterisk": {
            color: "#C0392B",
          },
        }}
      >
        {children}
      </InputLabel>
    );
  }

  return <Box sx={labelStyles}>{children}</Box>;
};

export default FormFieldLabel;
